import { FC } from 'react';
import { ProductManualGridStoryblok } from 'storyblok-types';
import { ProductManualGrid } from 'pages/StoryBlok/ProductManualGrid/ProductManualGrid';
import { IStoryBlokComponentProps } from 'pages/StoryBlok/types';
import { Facets, IFilter, IFilterParam } from 'commerce/factFinder/types';
import { client } from 'commerce/scayle/client';
import { Product } from 'commerce/scayle/utils/adapter';

export const ProductManualGridContainer: FC<
  IStoryBlokComponentProps<ProductManualGridStoryblok>
> = async ({ serverProps, blok }) => {
  const appliedBrandIds =
    serverProps.queryParams
      ?.get('substringFilter')
      ?.split(':')[1]
      ?.split(',') || [];

  const initFilters = [
    {
      name: 'brand',
      values: appliedBrandIds.map((brandId) => ({
        value: brandId,
        type: 'brand',
      })),
    },
  ] as unknown as IFilterParam[];

  const { entities, pagination } = await client.products.query({
    where: {
      categoryId: Number(blok.categoryId),
      ...(!!appliedBrandIds?.length
        ? {
            attributes: [
              {
                type: 'attributes',
                key: 'brand',
                values: appliedBrandIds,
              },
            ],
          }
        : {}),
    },
    with: {
      advancedAttributes: 'all',
    },
    includeSellableForFree: true,
    includeSoldOut: true,
    pagination: {
      page: serverProps.page,
    },
  });

  const products = entities.map((product) => {
    const parsedProduct = Product.createProduct(product).toJSON();

    return {
      id: parsedProduct.id,
      name: parsedProduct.name,
      full_slug: parsedProduct.pdfUrl,
      href: parsedProduct.pdfUrl,
      isHighlighted: false,
    };
  });

  const { entities: brandEntities } = await client.brands.get({
    pagination: { perPage: 1000 },
  });

  const brands: IFilter[] = brandEntities
    .map((brand) => ({
      value: brand.id.toString(),
      type: Facets.BRAND,
      displayValue: brand.name || '',
    }))
    .sort((a, b) => a.displayValue.localeCompare(b.displayValue));

  return (
    <ProductManualGrid
      products={products}
      pagination={pagination}
      brands={brands}
      initFilters={initFilters}
    />
  );
};
